import { FC } from 'react'
import s from './index.module.scss'
import cn from "classnames";

type Props = {
  benefits: {
    text: string
    src: string
    isVideo?: boolean
    isAutoplay?: boolean
  }[]
}

const Benefits:FC<Props> = ( { benefits }) => {
  return (
    <div className={s.root}>
      {benefits.map((item, index) => {
        if (item.src){
          return (
            <div className={s.items} key={index}>
              <div className={cn(s.text, !!(index%2) && s.mirror)}>
                {item?.text ? <div className={s.desc} dangerouslySetInnerHTML={{ __html: item.text}} /> : null}
              </div>
              {item.isVideo ? (
                <div className={s.video}>
                  <video
                    controls={!item.isAutoplay} loop={item.isAutoplay} muted={item.isAutoplay} playsInline={item.isAutoplay} autoPlay={item.isAutoplay} preload='metadata' src={item.src}
                  />
                </div>
              ) : (
                <div className={s.image}>
                  <img src={item.src} alt='' />
                </div>
              )}
            </div>
          )
        } else {
          return <div key={index} className={s.benefitMiddleItem} dangerouslySetInnerHTML={{ __html: item.text}} />
        }
       })}
    </div>
  )
}

export default Benefits
